import { render } from "./offerInfo1.vue?vue&type=template&id=4438bad2&scoped=true"
import script from "./offerInfo1.vue?vue&type=script&lang=js"
export * from "./offerInfo1.vue?vue&type=script&lang=js"

import "./offerInfo1.vue?vue&type=style&index=0&id=4438bad2&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4438bad2"]])

export default __exports__